<template>
	<div
		class="border-separator-secondary shadow-input flex h-10 min-w-0 items-center rounded-[10px] border bg-black pr-1.5 pl-3"
		@click="focusInput"
	>
		<SearchIcon class="text-label-secondary h-5 w-5" />
		<template v-if="!focus">
			<div class="text-label-secondary min-w-0 truncate py-2 pl-1.5 opacity-60">
				{{ search ? search : placeholder ? placeholder : t('search') }}
			</div>
		</template>
		<BaseInput
			v-else
			id="search"
			v-model="search"
			type="text"
			class="min-w-0 flex-1 py-2 pr-3 pl-1.5 disabled:opacity-60"
			ref="input"
			@focusout="focusOut"
			@enter="enter"
			@submit="enter"
		/>
	</div>
</template>
<script setup lang="ts">
import BaseInput from './BaseInput.vue'
import { nextTick, ref } from 'vue'
import SearchIcon from '@/assets/icons/search.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	messages: {
		en: {
			search: 'Type here...'
		},
		ru: {
			search: 'Печатай здесь...'
		}
	}
})

defineProps<{
	placeholder?: string
}>()

const search = defineModel<string>()

const emit = defineEmits<{
	(e: 'enter'): void
}>()

const focus = ref(false)
const input = ref()

const focusInput = async () => {
	if (focus.value) {
		return
	}

	focus.value = true

	await nextTick()

	if (!input.value) {
		focus.value = false
		return
	}

	input.value.focus()

	if (search.value) {
		input.value.select()
	}
}

const focusOut = () => {
	focus.value = false
}

const enter = () => {
	if (!search.value) {
		return
	}

	focus.value = false

	emit('enter')
}

defineExpose({
	focusInput,
	focusOut
})
</script>
